import React from 'react'
import BlueHeading from '../other/common/BlueHeading'
import Heading from '../common/ui/Heading';
import { SPOTLIGHT_LIST } from '../../utils/other-component';
import { Link } from 'react-router-dom';

const ShiningMoment = () => {
  return (
    <>
      <div>
        <div className="flex items-center justify-center flex-col">
          <BlueHeading text="Shining Moments" />
          <Heading children="In the Spotlight" />
        </div>
        <div className="max-w-[1140px] mx-auto pt-[50px] max-lg:pt-10 max-md:pt-6">
          <div className="flex flex-wrap items-center gap-6 w-full">
            {SPOTLIGHT_LIST.map((obj, i) => (
              <div
                key={i}
                className="w-full max-w-[558px] max-lg:mx-auto max-xl:max-w-[500px] border border-solid border-[#0101011A] rounded-2xl shadow-[0px_4px_17.7px_0px_#0000001A] p-[1px] transition-all ease-linear duration-300 hover:bg-[linear-gradient(270.39deg,rgba(152,198,78,0.7)_2.61%,rgba(63,138,49,0.7)_96.31%)]"
              >
                <div className="w-full bg-[#FEFEFE] h-full p-4 rounded-2xl max-xl:p-2">
                  <Link
                    href={obj.link}
                    className="w-full max-w-[526px] max-xl:max-w-[500px]"
                  >
                    <img alt="card-img" src={obj.img} />
                  </Link>
                  <h3 className="text-lg font-semibold leading-[150%] text-[#010101] pt-[15px] pb-[10px]">
                    {obj.title}
                  </h3>
                  <p className="text-[#383838] text-base font-normal leading-[150%]">
                    {obj.description}
                  </p>
                  <button className="text-[#297D4E] text-base leading-[150%] font-normal pt-3">{obj.btn}</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShiningMoment